<template>
  <div class="home-page">
      <Toolbar :icon="'searchCheck'" :title="'Digital Assets'"/>
      <ProductTable :columns="columns" :rows="paged" :currentPage="currentPage" :pages="this.pages" :changePageParent="this.setUnregisteredPage" />
  </div>
</template>

<script>
import Vue from "vue";
import { mapGetters } from "vuex";
import Toolbar from "@/components/Toolbar";
import ProductTable from "@/components/ProductTable/ProductTable";
import {
  FETCH_ASSETS
} from "@/store/actions.type";

const URL_MAX_SIZE = 64

export default {
  name: "products",
  computed: {
    ...mapGetters(["isAuthenticated"]),
    tag() {
      return this.$route.params.tag;
    },
    paged() {
      let pagedData = [];
      pagedData = this.assets.slice((this.currentPage - 1) * this.pageSize, this.currentPage * this.pageSize);
      console.log((this.currentPage - 1) * this.pageSize);
      return pagedData;
    }
  },
  data: function() {
      return {
          columns: [
            {key: 'image', style: {width: '10%' }},
            {key: 'gtin', style: {width: '15%', minWidth: '80px'}},
            {key: 'gln', style: {width: '15%', minWidth: '80px'}},
            {key: 'urlShort',  style: {width: '40%', minWidth: '200px'}},
            {key: 'hash', style: {width: '20%', minWidth: '100px'}}
          ],
          // assets: [],
          pageSize: 10,
          pages: 0,
          currentPage: 1,
          assets:  []
      }
  },
  components: {
      Toolbar,
      ProductTable
  },
  methods: {
    getQualified: function (json, fieldName, lang, defaultLang) {
      var ret = '';
      
      if(typeof json[fieldName] !== 'undefined' && typeof json[fieldName].qualified !== 'undefined') {
          for(var q in json[fieldName].qualified) {
            var qual = json[fieldName].qualified[q];
            if(typeof qual[lang] !== 'undefined') {
              ret = qual[lang];
            } else if(typeof qual[defaultLang] !== 'undefined') {
              ret = qual[defaultLang];
            }
          }
      }
      return ret;
    },
    setUnregisteredPage: function (page) {
      this.currentPage = page;
    }
  },
  mounted: function () {
    this.$store.dispatch(FETCH_ASSETS).then((data) => {
        console.log(data)
      for(var i in data.payload) {
        var item = data.payload[i];

        item.extendedData = '<img src="' + item.url + '" style="max-width: 200px"/><br/>';
        item.extendedData += '<a href="' + item.url + '" target="_blank">URL</a><br/>';
        item.extendedData += '<br/>Type Of Information: ' + item.typeOfInformation;
        item.extendedData += '<br/>Image Facing: ' + item.imageFacing;
        item.extendedData += '<br/>Uniform Resource Identifier: ' + item.uniformResourceIdentifier;
        item.extendedData += '<br/>File Effective Start Date Time: ' + item.fileEffectiveStartDateTime;

        if(item.url.length > URL_MAX_SIZE) {
            item.urlShort = item.url.substr(0, URL_MAX_SIZE) + '...'
        }

        item.image = item.url

        if(item.fileEffectiveStartDateTime !== null && typeof item.fileEffectiveStartDateTime.date !== 'undefined') {
            item.fileEffectiveStartDateTime = item.fileEffectiveStartDateTime.date
        }
        
      }

      this.assets = data.payload;
      
      
      this.currentPage = 1;
      //this.pages = Math.round(total / this.pageSize);
    });
  },
};
</script>
